import { createFileRoute } from "@tanstack/react-router";

import AddFacebook from "@/features/onboarding/AddFacebook";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-facebook")({
  component: () => (
    <BasicLayout>
      <AddFacebook />
    </BasicLayout>
  ),
});
